module.exports = __webpack_public_path__ + "img/store_vip_benefit_drop.a535d340.png";